export default moneyString => {
  const numberString = moneyString.replace('$', '').split(',').join('');

  return Number(numberString);
};
